import React from 'react';
import { Card } from '../ui/card';
import { Users, ShoppingBag, DollarSign } from 'lucide-react';

const StatsPanel = ({ stats, contacts }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Card className="p-6 bg-gradient-to-br from-blue-500 to-blue-600 text-white" data-testid="stat-contacts">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-blue-100 text-sm">Total Contacts</p>
            <p className="text-3xl font-bold mt-2">{stats?.total_contacts || 0}</p>
          </div>
          <Users className="h-12 w-12 text-blue-200" />
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-green-500 to-green-600 text-white" data-testid="stat-orders">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-green-100 text-sm">Total Orders</p>
            <p className="text-3xl font-bold mt-2">{stats?.total_orders || 0}</p>
          </div>
          <ShoppingBag className="h-12 w-12 text-green-200" />
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-purple-500 to-purple-600 text-white" data-testid="stat-revenue">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-purple-100 text-sm">Revenue</p>
            <p className="text-3xl font-bold mt-2">$0</p>
            <p className="text-xs text-purple-200 mt-1">Stripe webhook pending</p>
          </div>
          <DollarSign className="h-12 w-12 text-purple-200" />
        </div>
      </Card>
    </div>

    <Card className="p-6">
      <h3 className="text-lg font-bold text-gray-900 mb-4">Recent Contact Submissions</h3>
      {contacts.length === 0 ? (
        <p className="text-gray-500 text-center py-8">No contacts yet</p>
      ) : (
        <div className="space-y-3">
          {contacts.slice(0, 5).map((contact) => (
            <div key={contact.id} className="border-b border-gray-200 pb-3 last:border-0">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <p className="font-semibold text-gray-900">{contact.name}</p>
                  <p className="text-sm text-gray-600">{contact.email}</p>
                  <p className="text-sm text-gray-500 mt-1 line-clamp-2">{contact.message}</p>
                </div>
                <span className="text-xs text-gray-400">
                  {new Date(contact.created_at).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  </div>
);

export default StatsPanel;
